export enum LoadingStatus {
  Before = 'BEFORE',
  Fetching = 'FETCHING',
  Success = 'SUCCESS',
  Failed = 'FAILED',
  Forbidden = 'FORBIDDEN',
}
